<template>
  <div class="container">
    <CommonHeader
      title="调整款项-电力税补款"
      :value="value"
    />
    <LongList
      :api-method="getData"
    >
      <template #default="{list}">
        <BillTable
          :data="list"
          :columns="columns"
          :cell-class="getCellClass"
        />
      </template>
    </LongList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatAmount } from '@/util/filter';
import Api from '@/api/bill';
import BillTable from '@/components/BillTable';

export default {
  name: 'TaxRecharge',
  components: { BillTable },
  data() {
    const { amount } = this.$route.query;

    const columns = [
      {
        label: '月份',
        prop: 'cutMonth',
      },
      {
        label: '门店名称',
        prop: 'poiName',
      },
      {
        label: '补款金额',
        formatter: (row) => `${row.amount}元`,
      },
      {
        label: '备注',
        formatter: (row) => row.comment || '-',
        prop: 'comment',
      },
    ];

    return {
      value: `总金额：${formatAmount(amount)}元`,
      columns,
    };
  },
  computed: {
    ...mapState(['accountType']),
    ...mapState('billModule', ['currentBilledInfo', 'customerId']),
  },
  methods: {
    getData(pageNum, pageSize) {
      const { customerId, accountType } = this;
      const { cutMonth: billMonth } = this.currentBilledInfo;
      const params = {
        customerId,
        billMonth,
        accountType,
        pageSize,
        pageNum,
      };
      return Api.getTaxRechargeDetail(params);
    },
    getCellClass(cell) {
      const { row, column } = cell;
      if (column.prop === 'comment' && row.comment && row.comment !== '-') {
        return 'red';
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 16px;
}
/deep/ .red {
  color: red;
}
</style>
